import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { profileActions } from '../../../actions';
import { useLoggedUser } from '../../../hooks/useLoggedUser';
import { invalidateRequestCache, createRequestCacheKey } from '../../../helpers/requestCache';

// Helper function to compare scoreboard data
const isScoreboardDataChanged = (oldData, newData) => {
    if (!oldData && newData) return true;
    if (!newData) return false;
    if (oldData.length !== newData.length) return true;
    
    // Compare each score entry
    return oldData.some((oldScore, index) => {
        const newScore = newData[index];
        return (
            oldScore.StudentProfileID !== newScore.StudentProfileID ||
            oldScore.UserName !== newScore.UserName ||
            oldScore.Score !== newScore.Score
        );
    });
};

const ScoreDetails = () => {
    const dispatch = useDispatch();
    const [scoreboard, setScoreBoard] = useState(null);
    const loggedUser = useLoggedUser();

    useEffect(() => {
        if (!loggedUser?.data?.ClassID) return;
        
        // Invalidate cache to ensure fresh data from API every time
        invalidateRequestCache([
            createRequestCacheKey('profile', 'scoreboard', loggedUser.data.ClassID)
        ]);
        
        // Fetch fresh scoreboard data from API
        dispatch(profileActions.fetchScoreBoard(loggedUser.data.ClassID))
            .then((response) => {
                const newScoreboardData = response.data;
                
                // Only update state if data has changed
                if (isScoreboardDataChanged(scoreboard, newScoreboardData)) {
                    setScoreBoard(newScoreboardData);
                }
            })
            .catch((error) => {
                console.error('Error fetching scoreboard: ', error);
            });
    }, [dispatch, loggedUser.data.ClassID]);

    return (
        <React.Fragment>
            <div className="content" id="content">
                <div className="d-flex justify-content-center align-items-center flex-column">
                    <div className="tableWrap" style={{ width: '85%' }}>
                        <table className="w-100 text-center score-table">
                            <thead>
                                <tr>
                                    <th className="b-font score-th">Rank</th>
                                    <th className="b-font score-th">Player</th>
                                    <th className="b-font score-th">Score</th>
                                </tr>
                            </thead>
                            <tbody>
                                {scoreboard?.map((score, index) => (
                                    <tr key={score.StudentProfileID ?? `score-${index}`}>
                                        <td className="b-font score-td">{index + 1}</td>
                                        <td className="b-font score-td left-align">{score.UserName}</td>
                                        <td className="b-font score-td">{score.Score}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ScoreDetails;